import {
  Badge,
  Box,
  Center,
  Group,
  Image,
  Stack,
  Text,
  ThemeIcon,
  Tooltip,
  useMantineTheme,
} from "@mantine/core";
// import { get, set } from 'idb-keyval';
import React, { useCallback, useEffect, useRef, useState } from "react";
// import { ApprovalEventTypes } from '../ApprovalModule';
import CaptureToolbar from "./CaptureToobar";
import ResolverImage from "../resolverImage/ResolverImage";
import TagTalent from "core/components/capture/TagTalent";
import { createStyles } from "@mantine/emotion";
import ImagePreview from "../imagePreview/ImagePreview";
import { IconNote } from "@tabler/icons-react";

const useStyles = createStyles((theme, _, u) => ({
  imageContainer: {
    // marginLeft:`-${theme.spacing.lg}px`,
    // marginRight:`-${theme.spacing.lg}px`
    // borderBottom: `3px solid ${theme.colors.dark[6]}`,
    paddingTop: theme.spacing.sm,
    paddingLeft: theme.spacing.sm,
    paddingBottom: theme.spacing.sm,
    // background: theme.colors.dark[7],
    [u.light]: {
      background: theme.white,
    },
  },
  imageClass: {
    // ref: getRef('imageClass'),
    // border: "3px solid transparent",
    // padding: 3,
    maxWidth: "100%",
    objectFit: "contain",
    borderRadius: theme.radius.sm,
    // height:'100%',
    // width:'100%',
  },
  imageBadge: {
    position: "absolute",
    top: 0,
    left: 0,
    borderRadius: 0,
    borderBottomRightRadius: theme.radius.sm,
  },
  imageThumb: {
    borderRadius: theme.radius.md,
    // paddingTop: theme.spacing.xs,
    // border: `3px solid transparent`,
    ".imageWrapper": {
      border: `3px solid transparent`,
      borderRadius: theme.radius.md,
      padding: 3,
      position: "relative",
    },
    img: {
      userSelect: "none",
      // border: `3px solid transparent`,
    },
    "&.selected .imageWrapper": {
      // [`.${getRef('imageClass')}`]: {
      // borderColor: theme.colorScheme === 'dark' ? theme.colors.brand[3] : theme.colors.brand[2],
      borderColor: theme.colors.brand[3],
      [u.light]: {
        borderColor: theme.colors.brand[4],
      },
      // },
    },
    "&:hover": {
      background: theme.colors.dark[6],
      [u.light]: {
        background: theme.colors.gray[1],
      },
    },
    textAlign: "center",
    alignItems: "center",
    height: "100%",
  },
}));

const CaptureThumb = React.memo(
  ({
    image,
    onImageEvent,
    size = 200,
    selected,
    badgeLabel,
    onCaptureChange,
    showSettings = true,
    src,
    style = {},
    resolvePath = false,
    fit = "container",
    showPsdLoaded = false,
    imageHeight,
    imageWidth,
    showZoom = true,
    showNoteIndicator = false,
    showfilename = true
  }) => {
    // const [imageSrc,setImageSrc] = useState({original:'', url:''});
    const [showTagTalent, setShowTagTalent] = useState(false);

    const [imageSrc, setImageSrc] = useState(src);
    //    const [imageLoaded,setImageLoaded] = useState(false);

    const imgSrc = useRef({ original: "", url: "" });
    const imgRef = useRef();
    const isAliveRef = useRef(true);

    const theme = useMantineTheme();

    const onClick = useCallback(
      (event) => {
        onImageEvent(CaptureEventType.IMAGE_CLICK, image, event);
      },
      [image, onImageEvent]
    );

    const onDoubleClick = (event) => {
      onImageEvent(CaptureEventType.IMAGE_DBL_CLICK, image, event);
    };
    const { classes } = useStyles();

    const imgClass = selected ? " selected" : "";

    // issue caching the image so had to move this
    // to src change
    useEffect(() => {
      if (src && src.length) setImageSrc(src);
    }, [src]);

    const handleClick = (e) => {
      if (e.detail === 2) {
        onImageEvent(CaptureEventType.IMAGE_DBL_CLICK, image, e);
      } else {
        onImageEvent(CaptureEventType.IMAGE_CLICK, image, e);
      }
    };

    return (
      <Stack className={`${classes.imageThumb} ${imgClass}`} gap={0}>
        <div
          style={{
            ...style,
            position: "relative",
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={(e) => handleClick(e)}
        >
          {badgeLabel ? (
            <Badge
              size="xs"
              variant="gradient"
              gradient={{ from: "#ed6ea0", to: "#ec8c69", deg: 35 }}
              className={classes.imageBadge}
            >
              {badgeLabel}
            </Badge>
          ) : null}

          {/* style={{width:size,height:size}} */}

          {imageSrc && imageSrc.length ? (
            <div className={"imageWrapper"} style={{width:fit==='cover'?'100%':'auto'}}>

              {(image.clientNotes && showNoteIndicator) || (image.annotations && image.annotations.length > 0) && (
                <Box
                  style={{
                    position: "absolute",
                    top: 7,
                    right: 7,
                    zIndex: 90,
                  }}
                >
                  <Tooltip label={image.clientNotes || 'Has Annotations'}>
                    <ThemeIcon
                      size={"sm"}
                      radius={theme.radius.md}
                      variant="filled"
                      color="yellow.8"
                    >
                      <IconNote size={16} />
                    </ThemeIcon>
                  </Tooltip>
                </Box>
              )}

              {resolvePath ? (
                // <ResolverImage src={src} style={{ objectFit: 'container', maxWidth: size, maxHeight: size }} classes={`${classes.imageClass} unhightable`} />
                // <ResolverImage
                //   src={src}
                //   // height={size}
                //   // width={size}
                //   style={{
                //     objectFit: "container",
                //     maxWidth: size,
                //     maxHeight: size,
                //   }}
                //   radius={theme.radius.md}
                //   // width={fit==='contain'?'auto':size}
                //   // fit={'contain'}
                //   // style={{ objectFit: 'container', maxWidth: size, maxHeight: size }}
                //   classes={`${classes.imageClass} unhightable`}
                // />

                <ImagePreview
                  file={{ url: imageSrc }}
                  onClick={() => {}}
                  height={size}
                  width={"auto"}
                  fit={fit}
                />
              ) : (
                <>
                  {!showZoom ? (
                    <Image
                      alt={image.originalFilename}
                      ref={imgRef}
                      src={imageSrc}
                      // radius={theme.radius.md}
                      className={`${classes.imageClass} unhightable`}
                      // fit="contain"

                      style={{
                        maxWidth: size,
                        maxHeight: size,
                        objectFit: fit,
                        flex: 1,
                        minWidth: 0,
                      }}
                    />
                  ) : (
                    <ImagePreview
                      file={{ url: imageSrc }}
                      onClick={() => {}}
                      height={size}
                      width={"auto"}
                      fit={fit}
                    />
                  )}
                </>
              )}
            </div>
          ) : (
            <Group
              style={{
                height: "100%",
                width: "100%",
                justifyContent: "center",
              }}
            >
              <Center>
                {/* <Loader /> */}
                <Text size="sm" c={"dimmed"}>
                  Loading..
                </Text>
              </Center>
            </Group>
          )}

          {/* <img alt={image.originalFilename} src={image.previewLo} className={`${classes.imageClass} unhightable`}
                // fit="contain"
                height={size}
                sx={{maxWidth:size,maxHeight:size}}
                /> */}
        </div>
        {showSettings && image ? (
          <TagTalent
            opened={showTagTalent}
            onChange={setShowTagTalent}
            captures={[image]}
          >
            <Box position="apart" px={"xs"} py={"xs"} style={{ opacity: 1 }}>
              {/* <Text size={'xs'}>{imageSrc} </Text> */}
              {/* <Checkbox  /> */}
              <CaptureToolbar
                size={"sm"}
                image={image}
                rating={image.star}
                onCaptureChange={(type, data, items) => {
                  onCaptureChange(type, data, [image]);
                  if (type === CaptureEventType.TAG_TALENT) {
                    setShowTagTalent(true);
                  }
                }}
                status={image.sak}
              />
              <Group
                mt={"xs"}
                position={showPsdLoaded ? "apart" : "center"}
                justify="center"
              >
                <Text size={"xs"} c="dimmed" className="unhightable">
                  {image.originalFilename}
                </Text>
                {showPsdLoaded ? (
                  <>
                    {image.psdLoaded && image.psdLoaded === "Y" ? (
                      <Badge radius={0} size="sm">
                        PSD
                      </Badge>
                    ) : (
                      <Badge radius={0} opacity={0.3} color="dark" size="sm">
                        PSD
                      </Badge>
                    )}
                  </>
                ) : null}
              </Group>
            </Box>
          </TagTalent>
        ) : (
          <Box px={"xs"} style={{ opacity: 1 }}>
            {image && showfilename ? (
              <Text size={"xs"} c="dimmed" className="unhightable" mb={7}>
                {image.name}
              </Text>
            ) : null}
          </Box>
        )}
      </Stack>
    );
  }
);

function isEqual(prevProps, nextProps) {
  return false;
}

export default CaptureThumb;

export const CaptureEventType = {
  SELECT_CLICK: "selectClick",
  IMAGE_CLICK: "imageClick",
  IMAGE_DBL_CLICK: "imageDblClick",
  RATING_CHANGE: "ratingChange",
  STATUS_CHANGE: "statusChange",
  DOWNLOAD: "download",
  ASSIGN_TO_JOB: "assignToSession",
  SHOW_IN_CAPTURE_COMMENTS: "showInCaptureComments",
  SHOW_IN_CAPTURE_SINGLE: "showInCaptureSingle",
  SHOW_IN_CAPTURE: "showInCapture",
  CREATE_TASK: "captureCreatTask",
  BATCH_CREATE_TASK: "batchCaptureCreatTask",
  APPLY_STYLE_INFO: "captureApplyStyleInfo",
  TAG_TALENT: "captureTagTalent",
  ARCHIVE: "captureArchive",
  UNARCHIVE: "captureUnArchive",
  MARK_COMPLETED: "markCompleted",
  NOTES_CHANGE: "notesChange",
  SHOW_BATCH_NOTES_EDITOR: "showBatchNotesEditor",
};

export const CaptureStatusTypes = {
  APPROVED: "approved",
  REJECTED: "rejected",
  ARCHIVED: "archived",
  ACTIVE: "active",
  COMPLETED: "completed",
};
